<template>
  <div class="nav-scroller">
    <nav class="nav-scroller-nav w-100">
      <ul class="nav-pills nav-scroller-content" id="pills-tab" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          v-for="day in conferenceStore.selected.conference_days"
          :key="day.conference_days_id"
        >
          <button
            class="btn"
            id="day1-button"
            data-bs-toggle="pill"
            data-bs-target="#day1-content"
            type="button"
            role="tab"
            aria-controls="day1-button"
            aria-selected="true"
            :class="{ active: isActive(day) }"
            @click="selectDay(day)"
          >
          
            <!-- <small>{{ dayjs(day.start).locale($i18n.locale).format("ddd") }}</small> -->
            <span>{{ dayjs(day.start).locale($i18n.locale).format("MMM") }} {{ dayjs(day.start).locale($i18n.locale).format("D") }}</span>
            <small>{{ dayjs.utc(day.start).format("h:mm A") }} - {{ dayjs.utc(day.end).format("h:mm A") }}</small>
            <small>{{ getMeetingTypesLabel(day) }}</small>
          </button>
          
        </li>
      </ul>
    </nav>

    <button
      class="nav-scroller-btn nav-scroller-btn--left"
      @change="navChange()"
      aria-label="Scroll left"
    >
      <i class="bi bi-chevron-left"></i>
    </button>

    <button
      class="nav-scroller-btn nav-scroller-btn--right"
      @change="navChange()"
      aria-label="Scroll right"
    >
      <i class="bi bi-chevron-right"></i>
    </button>
  </div>
</template>
<script setup>
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useTeacherStore } from "@/stores/parent/teacher";
import { useMatrixStore } from "@/stores/parent/matrix";
import { useConferenceStore } from "@/stores/parent/conference";
import { useAgendaStore } from "@/stores/parent/agenda";
import dayjs from "dayjs";

import PriorityNavScroller from "priority-nav-scroller";

const { t } = useI18n();

const TYPE_ORDER = ["in_person", "virtual", "phone", "callback"];
const TYPE_KEYS = {
  in_person: "message.AgendaCard.in_person",
  virtual: "message.AgendaCard.virtual",
  phone: "message.AgendaCard.phone",
  callback: "message.AgendaCard.callback"
};

function getMeetingTypesLabel(day) {
  const mt = day?.meeting_types;
  if (!mt) return "";
  const enabled = TYPE_ORDER.filter((k) => mt[k] === true);
  if (enabled.length === 0) return "";
  if (enabled.length === 1) return t(TYPE_KEYS[enabled[0]]);
  if (enabled.length === 2) return `${t(TYPE_KEYS[enabled[0]])} & ${t(TYPE_KEYS[enabled[1]])}`;
  return t("message.AgendaCard.hybrid");
}

onMounted(() => {
  // Init multiple nav scrollers with the same options
  let navScrollers = document.querySelectorAll(".nav-scroller");

  navScrollers.forEach((currentValue) => {
    PriorityNavScroller({
      selector: currentValue
    });
  });
});

function navChange() {
  document.querySelectorAll(".nav-scroller-btn.active");
}

const conferenceStore = useConferenceStore();
const teacherStore = useTeacherStore();
const matrixStore = useMatrixStore();
const agendaStore = useAgendaStore();

defineProps({
  days: Object
});
function isActive(day) {
  return day.conference_days_id == conferenceStore.selectedDay.conference_days_id;
}
function selectDay(day) {
  conferenceStore.selectedDay = day;
  teacherStore.selected.forEach((t) => {
    if (isAttending(t.value, day)) {
      fetchTimeslots(t.value);
    } else {
      t.value.timeslots = [];
    }
  });
  refreshMatrix();
}
function refreshMatrix() {
  // default minimum interval in 15
  matrixStore.smallestTimeInterval = 15;
  teacherStore.selected.forEach((t) => {
    var timeInterval = conferenceStore.selectedDay.time_interval;
    const day = t.value.conferencedays.find(
      (day) => day.conference_days_id == conferenceStore.selectedDay.conference_days_id
    );

    if (day !== undefined) {
      timeInterval = day.time_interval;
    } else {
      console.log(t.value.name + " is not available on this day");
    }
    if (matrixStore.smallestTimeInterval != null) {
      if (timeInterval < matrixStore.smallestTimeInterval) {
        matrixStore.smallestTimeInterval = timeInterval;
      }
    } else {
      matrixStore.smallestTimeInterval = timeInterval;
    }
  });

  // getTeacherConflict(teacher);
  // getTimeslots(teacher);
}

function isAttending(teacher, day) {
  if (
    teacher.conferencedays.findIndex((d) => d.conference_days_id == day.conference_days_id) >= 0
  ) {
    return true;
  } else {
    return false;
  }
}

async function fetchTimeslots(teacher) {
  if (teacher.teacher_id !== undefined && teacher.teacher_id != null && teacher.teacher_id != "") {
    teacher.conflicts = await teacherStore.fetchTeacherConflict(
      conferenceStore.selectedDay,
      teacher
    );
  } else {
    teacher.conflicts = await teacherStore.fetchTeamConflict(conferenceStore.selectedDay, teacher);
  }
  // teacher.conflicts = await teacherStore.fetchTeacherConflict(conferenceStore.selectedDay, teacher);
  // const startTime = conferenceStore.selectedDay.start;
  // const endTime = conferenceStore.selectedDay.end;
  const index = teacherStore.getSelectedIndexById(teacher.uid);
  const timeInterval = teacherStore.selected[index].value.conferencedays.find(
    (day) => day.conference_days_id == conferenceStore.selectedDay.conference_days_id
  ).time_interval;
  teacherStore.createTeacherTimeslots(
    teacherStore.selected[index].value,
    conferenceStore.selectedDay,
    timeInterval,
    agendaStore.agenda
  );
  teacherStore.clearDisabledTimeslots(teacherStore.selected[index].value);
  agendaStore.agenda
    .filter(
      (meeting) => meeting.conference_days_id == conferenceStore.selectedDay.conference_days_id
    )
    .forEach((meeting) => {
      teacherStore.disableTimeslots(
        teacherStore.selected[index].value,
        conferenceStore.selectedDay,
        meeting
      );
    });
}
</script>
